<div class="row">
  <div class="col-md-12 section-header">
    {{ 'bikeshop.rentals.configuration.override_store_times' | translate }}
  </div>
</div>

<div class="info" *ngIf="!loadingOverrideTimes && overrideTimes.length === 0">
  {{'bikeshop.rentals.configuration.override_store_times_info' | translate}}</div>

<div class="loader" *ngIf="deleting"></div>

<table class="data margin-top-16" *ngIf="overrideTimes.length > 0">
  <tr>
    <th>{{'bikeshop.shop_profile.collections.override_date' | translate}}</th>
    <th>{{'bikeshop.rentals.configuration.open_time' | translate}}</th>
    <th>{{'bikeshop.rentals.configuration.close_time' | translate}}</th>
    <th>{{'bikeshop.rentals.configuration.is_open' | translate}}</th>
    <th>
      <span *ngIf="canAddOverrideSlots()" class="hubtiger-add pull-right" (click)="addNew()"></span>
    </th>
  </tr>
  <tbody>
  <tr *ngFor="let item of overrideTimes;let i = index;">
    <td>{{item.date | date : countryData.AngularDateFormat}}</td>
    <td>{{item.isWorking && item.startTime ? ('1970-01-01 ' + item.startTime | date : "h:mm a") : '-'}}</td>
    <td>{{item.isWorking && item.endTime ? ('1970-01-01 ' + item.endTime | date : "h:mm a") : '-'}}</td>
    <td>{{(item.isWorking ? 'general.yes' : 'general.no') | translate}}</td>
    <td>
      <span class="fa hubtiger-edit" (click)="editRecord(item)"></span>
      <span class="fa hubtiger-delete" (click)="deleteRecord(item, i)"></span>
    </td>
  </tr>
  </tbody>
</table>

<div *ngIf="!loadingOverrideTimes && overrideTimes.length === 0  && canAddOverrideSlots()"
     class="margin-top-16 create-new">
  <button pButton type="button" class="p-button-raised full-width accent"
          label="{{'bikeshop.shop_profile.collections.buttons.add' | translate}}" (click)="addNew()"></button>
</div>

<p-sidebar #NavSideBar [(visible)]="showOverrideStoreTime" position="right"
           [style]="{width:'40em', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="getOverrideStoreTimes(); NavSideBar.destroyModal()">
  <div *ngIf="showOverrideStoreTime">
    <app-add-edit-rental-override-store-time [data]="panelData" [configuration]="configuration"
                                             (close)="closePanel($event)">
    </app-add-edit-rental-override-store-time>
  </div>
</p-sidebar>
